import Swiper from 'swiper/bundle';

const product_slider = document.querySelectorAll('[id^="product_slider_"]');

product_slider.forEach(el => {
    let large_slider = new Swiper('#' + el.id + ' .swiper', { // eslint-disable-line no-unused-vars
        slidesPerView: 1.25,
        slidesPerGroup: 1,
        spaceBetween: 55,
        navigation: {
            nextEl: '#' + el.id + ' .swiper-button-next',
            prevEl: '#' + el.id + ' .swiper-button-prev',
        },
        breakpoints: {
            550: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 55,
            },
            768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 55,
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 55,
            },
            1600: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 55,
            },
        },
    });
});
